import React, { useEffect, useState } from "react";
import { Route, Link, Switch, useParams, useLocation} from "react-router-dom";
import quizService from "../../services/quiz.service";
import QuizPage from "./quiz-page.component";
import { Label, Button, Modal, Checkbox, DropDownInput, Input } from '../../util/ui'
import CreateQuizModal from "./quiz.createQuiz.component";

const Quiz = () => {
  const [quizSelected, setQuizSelected] = useState(false);
  const [quizzes, setQuizzes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentQuiz, setCurrentQuiz] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const numQuestions = location.state?.numQuestions || 0;
  useEffect(() => {
    // const fetchQuizObj = async (quiz_id) => {
    //   try {
    //     const currentQuiz = await quizService.getQuiz(quiz_id);
    //   } catch (error) {
    //     console.error("Error fetching quizz: ", error)
    //     setLoading(false);
    //   }
    // }
    const fetchQuizTake = async (quiz_id) => {
      const author = JSON.parse(localStorage.getItem("user")).username;
      try {
        const cur_quiz = await quizService.takeQuiz(author, quiz_id, numQuestions);
        setQuizSelected(true);
        setCurrentQuiz(cur_quiz);
        setLoading(false);
      } catch (error) {
        console.error("Error starting quiz:", error);
        setLoading(false);
      }
    };
    fetchQuizTake(id);
  }, [id, numQuestions]);

  const handleFinishQuiz = async () => {
    try {
      await quizService.submitQuiz(currentQuiz.quiz_attempt_id)
      setCurrentQuiz(null);
      setQuizSelected(false);
    } catch (error) {
      console.error("Error submitting quiz:", error);
    }
  }

  if (loading) {
    return <p>Loading quizzes...</p>;
  }

  return (
    <div>
      <QuizPage quiz={currentQuiz} onFinishQuiz={handleFinishQuiz} />
    </div>
  )
};

export default Quiz;